<script setup lang="ts">
import { Stars, getDisplayName } from '@magma-app/magma-lapilli';

interface Props {
  review: {
    comment?: string;
    rating: number;
    user: {
      firstname: string;
      lastname: string;
      position?: string;
      profilePictureUrl: string;
    };
    organization: {
      name: string;
      logoUrl: string;
    };
  };
}

defineProps<Props>();
</script>

<template>
  <div
    class="p-10 rounded-lg shadow-lg bg-white md:min-w-[512px] w-full md:w-fit border border-border-subtle"
  >
    <div class="flex gap-3 items-center mb-6">
      <img
        :src="review.user.profilePictureUrl"
        :alt="getDisplayName(review.user.firstname, review.user.lastname)"
        class="w-12 h-12 rounded-full"
      />
      <div>
        <p class="text-mgm-txt-md font-medium text-foreground-emphasis">
          {{ getDisplayName(review.user.firstname, review.user.lastname) }}
        </p>
        <p
          v-if="review.user.position"
          class="text-mgm-txt-md text-foreground-default"
        >
          {{ review.user.position }}
        </p>
      </div>
    </div>
    <Stars :rating="review.rating" />
    <p
      v-if="review.comment"
      class="mt-4 text-mgm-txt-lg text-foreground-emphasis"
    >
      {{ review.comment }}
    </p>
  </div>
</template>
